import { render, staticRenderFns } from "./add_rule.vue?vue&type=template&id=311bcc5f&scoped=true&"
import script from "./add_rule.vue?vue&type=script&lang=js&"
export * from "./add_rule.vue?vue&type=script&lang=js&"
import style0 from "./add_rule.vue?vue&type=style&index=0&id=311bcc5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311bcc5f",
  null
  
)

export default component.exports